import React from "react";
import classNames from "classnames";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function OpenAll({ isDisabled, toggle }: Props) {
  return (
    <div
      className={classNames(styles.openAll, {
        [styles.disabled]: isDisabled,
      })}
      onClick={toggle}
    >
      <ToggleArrow className={styles.toggleArrow} />
    </div>
  );
}

export { OpenAll };
